import { render } from "./AutoWidthOption.vue?vue&type=template&id=a8176e0a"
import script from "./AutoWidthOption.vue?vue&type=script&lang=ts"
export * from "./AutoWidthOption.vue?vue&type=script&lang=ts"
script.render = render

export default script